<div [class]="{ 'px-sm-3': !suppressUI, 'px-md-4': !suppressUI }" class="ms-sm-auto font-size-sm">
  <div [class.d-none]="suppressUI" class="mb-2">{{ geoFilterVerbiage }} <small>(default geographic filter preferences can be set in your <a [routerLink]="['/account/userprofile']">user profile</a>)</small></div>
  <form #geoFilterForm="ngForm" class="row row-cols-lg-auto g-3 align-items-center">
    <div class="col-12">
      <div class="input-group mb-2">
        <label class="input-group-text" for="fieldDivisionFilter"><span class="visually-hidden">Filter by </span>Field Division</label>
        <select id="fieldDivisionFilter" class="form-select" name="fieldDivisionID" (change)="onSelectFieldDivision($event['target'])" [value]="geographicFilterModel.fieldDivisionID">
          <option value="all" selected>All</option>
          <ng-container *ngIf="fieldDivisions$ | async as fieldDivisions">
            <option *ngFor="let fieldDiv of fieldDivisions" [value]="fieldDiv.FieldDivisionID" [selected]="geographicFilterModel.fieldDivisionID == fieldDiv.FieldDivisionID">{{fieldDiv.FieldDivisionName}}</option>
          </ng-container>
        </select>
      </div>
    </div>
    <div class="col-12">
      <div class="input-group mb-2">
        <label class="input-group-text" for="fdGroupFilter"><span class="visually-hidden">Filter by</span> Field Division Group</label>
        <ng-container *ngIf="fieldDivisionGroups$ | async as fdGroups">
          <p-multiSelect #fdgroupms inputId="fdGroupFilter" [(ngModel)]="geographicFilterModel.fieldDivisionGroups" [options]="fdGroups" optionLabel="GroupName" name="fieldDivisionGroups" optionDisabled="Inactive" placeholder="All" dataKey="IntelligenceReportATFReferralGroupsID" styleClass="form-select" ariaFilterLabel="Filter by field division group" [maxSelectedLabels]="3" [showToggleAll]="false" [resetFilterOnHide]="true" filterBy="GroupName" (onChange)="onSelectFieldDivisionGroup($event)" [virtualScroll]="true" [virtualScrollItemSize]="30" appendTo="body">
            <ng-template let-selectedFDGroups pTemplate="selectedItems">
              <ng-container *ngIf="selectedFDGroups?.length <= 3">
                <span *ngFor="let selectedFDGroup of selectedFDGroups; let last = last">{{selectedFDGroup.GroupName}} ({{selectedFDGroup.Inactive | booleanTransform: 'Inactive' : 'Active'}})<span *ngIf="!last">;&nbsp;</span></span>
              </ng-container>
              <ng-container *ngIf="selectedFDGroups?.length > 3">
                {{ selectedFDGroups?.length }} items selected
              </ng-container>
              <ng-container *ngIf="!selectedFDGroups || selectedFDGroups?.length === 0">
                All
              </ng-container>
            </ng-template>
            <ng-template let-group pTemplate="item">
              <div>{{group.GroupName}} ({{group.Inactive | booleanTransform: 'Inactive' :'Active'}})</div>
            </ng-template>
          </p-multiSelect>
        </ng-container>
      </div>
    </div>
    <div class="col-12">
      <div class="input-group mb-2">
        <label class="input-group-text" for="stateFilter"><span class="visually-hidden">Filter by </span>State</label>
        <select id="stateFilter" class="form-select" name="stateID" [value]="geographicFilterModel.stateID" (change)="onSelectState($event['target'])">
          <option value="all" selected>All</option>
          <ng-container *ngIf="states$ | async as states">
            <option *ngFor="let state of states" [value]="state.StateID" [selected]="geographicFilterModel.stateID == state.StateID">{{state.StateName}}</option>
          </ng-container>
        </select>
      </div>
    </div>
    <div class="col-12">
      <div class="input-group mb-2">
        <label class="input-group-text" for="countiesFilter"><span class="visually-hidden">Filter by</span> County</label>
        <ng-container *ngIf="counties$  | async as counties">
          <p-multiSelect #countyms [(ngModel)]="geographicFilterModel.counties" [options]="counties" optionLabel="CountyName" name="counties" placeholder="All" dataKey="CountyID" inputId="countiesFilter" styleClass="form-select" ariaFilterLabel="Filter by county name" [maxSelectedLabels]="3" [showToggleAll]="false" (onChange)="onSelectCounties($event)" [resetFilterOnHide]="true" filterBy="CountyName,ENESS_REF_State.StateAbbreviation" [virtualScroll]="true" [virtualScrollItemSize]="30" appendTo="body">
            <ng-template let-selectedCounties pTemplate="selectedItems">
              <ng-container *ngIf="selectedCounties?.length <= 3">
                <span *ngFor="let county of selectedCounties; last as isLast">{{county.CountyName}}, {{county.ENESS_REF_State.StateAbbreviation}}<span *ngIf="!isLast">;&nbsp;</span> </span>
              </ng-container>
              <ng-container *ngIf="selectedCounties?.length > 3">{{ selectedCounties.length }} items selected</ng-container>
              <ng-container *ngIf="!selectedCounties || selectedCounties?.length === 0">All</ng-container>
            </ng-template>
            <ng-template let-county pTemplate="item">
              <div>{{county.CountyName}}, {{county.ENESS_REF_State?.StateAbbreviation}}</div>
            </ng-template>
          </p-multiSelect>
        </ng-container>
      </div>
    </div>
    <div class="col-12">
      <div class="input-group mb-2">
        <label class="input-group-text" for="agenciesFilter"><span class="visually-hidden">Filter by</span> Agency</label>
        <ng-container *ngIf="agencies$  | async as agencies">
          <p-multiSelect #agencyms [(ngModel)]="geographicFilterModel.agencies" [options]="agencies" optionLabel="AgencyName" name="agencies" placeholder="All" dataKey="AgencyID" inputId="agenciesFilter" styleClass="form-select" ariaFilterLabel="Filter by law enforcement agency name" [maxSelectedLabels]="3" [showToggleAll]="false" (onChange)="onSelectAgencies($event)" [resetFilterOnHide]="true" filterBy="AgencyName" [virtualScroll]="true" [virtualScrollItemSize]="30" appendTo="body">
            <ng-template let-selectedAgencies pTemplate="selectedItems">
              <ng-container *ngIf="selectedAgencies?.length <= 3">
                <span *ngFor="let agency of selectedAgencies; last as isLast">{{agency.AgencyName}}<span *ngIf="!isLast">;&nbsp;</span> </span>
              </ng-container>
              <ng-container *ngIf="selectedAgencies?.length > 3">{{ selectedAgencies.length }} items selected</ng-container>
              <ng-container *ngIf="!selectedAgencies || selectedAgencies?.length === 0">All</ng-container>
            </ng-template>
          </p-multiSelect>
        </ng-container>
      </div>
    </div>
  </form>
</div>
